import script from "./Payments.vue?vue&type=script&setup=true&lang=js"
export * from "./Payments.vue?vue&type=script&setup=true&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=603bdb64&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-603bdb64"]])

export default __exports__